var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitetoggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6476 39.415L64.0002 27.332L50.1246 27L38.3076 39.415L50.1246 51.8299L64.0002 51.5644L52.6476 39.415Z",
    fill: "#D0004B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0746 27.0664L43.8175 27L32 39.415L43.8175 51.8299H46.0746L34.3239 39.415L46.0746 27.0664Z",
    fill: "#D0004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitetoggle);
export default __webpack_public_path__ + "static/media/whitetoggle.464d41780fc83a94bb68caf70d7e78ad.svg";
export { ForwardRef as ReactComponent };